/* eslint-disable */
/**
 * @note This is an auto-generated file. Do not modify it directly.
 * @see https://devdocs.transfix.io/graphql
 *
 * If you need to update the hooks or definitions in this file:
 * 1. Edit the .graphql file in this directory with the same name
 * 2. Run `npm run generate:graphql:fms` or
 *    `npm run generate:graphql:fms:local` in the terminal
 */

import * as Types from '../../../../../../../types/FMSGraphqlTypes'

import { gql } from '@apollo/client'
import { ActiveShipmentFragmentDoc } from './ActiveShipmentFragment'
import * as Apollo from '@apollo/client'
const defaultOptions = {}
export type IActiveShipmentsQueryVariables = Types.Exact<{ [key: string]: never }>

export type IActiveShipmentsQuery = { __typename?: 'Query' } & {
  shipments: { __typename?: 'ShipmentConnection' } & Pick<
    Types.IShipmentConnection,
    'totalCount' | 'trackingStatusCount'
  > & {
      nodes?: Types.Maybe<
        Array<
          Types.Maybe<
            { __typename?: 'Shipment' } & Pick<Types.IShipment, 'id' | 'marketplaceId'> & {
                drivers?: Types.Maybe<
                  Array<
                    { __typename?: 'Driver' } & Pick<Types.IDriver, 'id' | 'firstName' | 'lastName'>
                  >
                >
                etaObject?: Types.Maybe<
                  { __typename?: 'EtaObject' } & Pick<
                    Types.IEtaObject,
                    'onTime' | 'lastPingLatitude' | 'lastPingLongitude'
                  >
                >
                stops: Array<
                  { __typename?: 'Stops' } & Pick<Types.IStops, 'id' | 'city' | 'stateCode'>
                >
                trackingSummary?: Types.Maybe<
                  { __typename?: 'ShipmentTrackingSummary' } & Pick<
                    Types.IShipmentTrackingSummary,
                    'isTracking'
                  >
                >
                truck?: Types.Maybe<
                  { __typename?: 'Truck' } & Pick<Types.ITruck, 'id' | 'truckNumber'>
                >
              }
          >
        >
      >
    }
}

export const ActiveShipmentsDocument = gql`
  query ActiveShipments {
    shipments(
      status: [
        ready_for_dispatch
        dispatched
        at_pickup
        loading
        in_transit
        in_yard
        at_dropoff
        unloading
        claim
      ]
      maxAge: 30
      shipmentSource: [external]
    ) {
      totalCount
      trackingStatusCount
      nodes {
        ...ActiveShipment
      }
    }
  }
  ${ActiveShipmentFragmentDoc}
`

/**
 * __useActiveShipmentsQuery__
 *
 * To run a query within a React component, call `useActiveShipmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useActiveShipmentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useActiveShipmentsQuery({
 *   variables: {
 *   },
 * });
 */
export function useActiveShipmentsQuery(
  baseOptions?: Apollo.QueryHookOptions<IActiveShipmentsQuery, IActiveShipmentsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<IActiveShipmentsQuery, IActiveShipmentsQueryVariables>(
    ActiveShipmentsDocument,
    options
  )
}
export function useActiveShipmentsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<IActiveShipmentsQuery, IActiveShipmentsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<IActiveShipmentsQuery, IActiveShipmentsQueryVariables>(
    ActiveShipmentsDocument,
    options
  )
}
export type ActiveShipmentsQueryHookResult = ReturnType<typeof useActiveShipmentsQuery>
export type ActiveShipmentsLazyQueryHookResult = ReturnType<typeof useActiveShipmentsLazyQuery>
export type ActiveShipmentsQueryResult = Apollo.QueryResult<
  IActiveShipmentsQuery,
  IActiveShipmentsQueryVariables
>
